<div class="form-field" [formGroup]="group" [ngStyle]="field.containerStyles">
  <mat-checkbox [gioEnableControl]="isEnabledFn(field.name, field.id)" [ngStyle]="field.checkboxStyles"
    [required]="field.required" [formControlName]="field.name" [color]="field.color" >
    <span [innerHTML]="field.label | gioNoSanitize"></span>
  </mat-checkbox>
</div>
